import { Flex, HStack, Text } from '@chakra-ui/react';

import { formatMoney } from '../../../../../../utils/helpers';
import { OfferStatusBadges } from '../offers/OfferStatusBadges';
import { ConversationTarget, PLATFORM_LABEL } from './utils';

type ConversationHeaderProps = {
  target: ConversationTarget;
};

const ConversationHeader = ({ target }: ConversationHeaderProps) => {
  if (target.kind === 'platform') {
    return (
      <Flex direction="column" gap="8px">
        <Text
          as="span"
          fontFamily="heading"
          fontSize="16px"
          fontWeight="700"
          letterSpacing="0.02em"
          color="leaseEndBlue"
        >
          {PLATFORM_LABEL}
        </Text>
        {target.contextNote != null && (
          <Text
            bg="iceBlue"
            color="leaseEndBlue"
            fontSize="13px"
            fontWeight="500"
            lineHeight="1.4"
            borderRadius="8px"
            px="10px"
            py="6px"
          >
            {target.contextNote}
          </Text>
        )}
      </Flex>
    );
  }

  if (target.kind === 'won') {
    const { dealershipName, repName, amount } = target;
    const hasRep = repName != null && repName !== '';
    return (
      <Flex direction="column" gap="4px">
        <Text
          as="span"
          fontFamily="heading"
          fontSize="16px"
          fontWeight="700"
          letterSpacing="0.02em"
          color="leaseEndBlue"
        >
          {dealershipName}
        </Text>
        <HStack spacing="6px" align="baseline">
          {amount != null && (
            <Text as="span" fontSize="14px" fontWeight="700" color="greenDark">
              {formatMoney(amount)}
            </Text>
          )}
          {hasRep && (
            <Text as="span" fontSize="12.5px" color="grayMedium">
              {repName}
            </Text>
          )}
        </HStack>
      </Flex>
    );
  }

  if (target.kind === 'inactive') {
    const { dealerLabel, amount } = target.card;
    return (
      <Flex direction="column" gap="6px">
        <HStack spacing="8px" align="center" wrap="wrap">
          <Text
            as="span"
            fontFamily="heading"
            fontSize="15px"
            fontWeight="700"
            letterSpacing="0.02em"
            textTransform="uppercase"
            color="grayMedium"
          >
            Offer {dealerLabel}
          </Text>
          <OfferStatusBadges card={target.card} />
        </HStack>
        <Text
          as="span"
          fontSize="22px"
          fontWeight="700"
          lineHeight="1.1"
          color="offerInactiveInk"
          textDecoration="line-through"
        >
          {formatMoney(amount)}
        </Text>
      </Flex>
    );
  }

  const { card } = target;
  const { dealerLabel, amount, driverCounterAmount } = card;
  const isWaiting = driverCounterAmount != null;

  return (
    <Flex direction="column" gap="6px">
      <Text
        as="span"
        fontFamily="heading"
        fontSize="16px"
        fontWeight="700"
        letterSpacing="0.02em"
        color="leaseEndBlue"
      >
        Offer {dealerLabel} · {formatMoney(isWaiting ? driverCounterAmount : amount)}
      </Text>
      <HStack spacing="8px" align="center" wrap="wrap">
        <OfferStatusBadges card={card} />
      </HStack>
    </Flex>
  );
};

export default ConversationHeader;
